// extracted by mini-css-extract-plugin
export var form = "_59681076b21fa49d00564623c4e3646e-css";